<div class="page-content page-fill">
  <dx-chart #chart [dataSource]="generalFund" title="Monthly Giving, General Fund" (onPointClick)="onPointClick($event)" (onLegendClick)="legendClickHandlerOffering($event)">
    <!-- <dxi-series valueField="gCEOFAmount" argumentField="month" name="GCEOF"></dxi-series> -->
    <dxo-common-series-settings argumentField="month" valueField="generalFundAmount" type="bar">
      <dxo-label [visible]="false" [format]="{ type: 'currency', precision: 2 }"> </dxo-label>
    </dxo-common-series-settings>
    <dxo-series-template nameField="year"></dxo-series-template>
    <!-- <dxi-series valueField="generalFundAmount" argumentField="year" name="General Fund"></dxi-series> -->
    <dxi-value-axis>
      <dxi-constant-line [width]="2" [value]="monthlyBudget" color="#8c8cff" dashStyle="dash">
        <dxo-label [text]="monthlyBudgetIndicator"></dxo-label>
      </dxi-constant-line>
      <dxi-constant-line [width]="2" [value]="monthlyExpense" color="#c00000" dashStyle="dash">
        <dxo-label [text]="monthlyExpenseIndicator" [verticalAlignment]="'bottom'"></dxo-label>
      </dxi-constant-line>
    </dxi-value-axis>
    <dxo-tooltip [enabled]="true" [format]="{ type: 'currency', precision: 2 }"></dxo-tooltip>
    <dxo-export [enabled]="true"></dxo-export>
    <dxo-argument-axis [visualRange]="visualRange"> </dxo-argument-axis>
  </dx-chart>
  @if (visualRange) {
    <dx-range-selector [dataSource]="generalFund" [(value)]="visualRange">
      <dxo-size [height]="80"></dxo-size>
      <dxo-margin [left]="5"></dxo-margin>
      <dxo-scale [minorTickCount]="1"></dxo-scale>
      <dxo-behavior valueChangeMode="onMoving"></dxo-behavior>
      <dxo-chart>
        <dxi-series argumentField="month" valueField="generalFundAmount"></dxi-series>
        <!-- <dxi-series argumentField="month" valueField="gCEOFAmount" type="line"></dxi-series> -->
      </dxo-chart>
    </dx-range-selector>
  }

  <dx-chart
    class="mt-3"
    id="offeringChart"
    [dataSource]="offeringHistory"
    title="Recent Offerings"
    (onPointClick)="pointClickHandlerOffering($event)"
    (onLegendClick)="legendClickHandlerOffering($event)"
        [argumentAxis]="{
            argumentType: 'datetime',
            label: { format: 'shortDate' },
            type: 'discrete'
        }"
    >
    <dxi-value-axis name="amountAxis" [label]="{ format: 'currency' }" [autoBreaksEnabled]="false" [maxAutoBreakCount]="1" [breaks]="breaks">
      <dxo-title text="Offering Amount"></dxo-title>
      <dxo-break-style [line]="lineStyleValue"> </dxo-break-style>
    </dxi-value-axis>
    <dxi-value-axis name="countAxis"> </dxi-value-axis>
    <dxi-series axis="amountAxis" valueField="amount" name="Total"> </dxi-series>
    <!-- <dxi-series axis="countAxis" valueField="count" name="Count"> </dxi-series> -->

    <dxo-common-series-settings type="bar" argumentField="date" [ignoreEmptyPoints]="true"></dxo-common-series-settings>
    <dxo-argument-axis [visualRange]="visualRangeOffering"></dxo-argument-axis>
    <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeToolTipOfferingHistory"></dxo-tooltip>
  </dx-chart>

  <!-- <dx-range-selector *ngIf="visualRangeOffering" [dataSource]="offeringHistory" dataSourceField="dateString" [(value)]="visualRangeOffering">
  <dxo-size [height]="80"></dxo-size>
  <dxo-scale valueType="string" tickInterval="month" minorTickInterval="week" [endOnTick]="true" [minorTick]="{ visible: false }">
    <dxo-label format="shortDate"></dxo-label>
  </dxo-scale>
  <dxo-slider-marker format="shortDate"></dxo-slider-marker>
  <dxo-behavior [valueChangeMode]="'onMoving'"></dxo-behavior>
</dx-range-selector> -->

<div class="row">
  <dx-chart class="mt-3 col-sm-6" id="chart" [dataSource]="generalFundOverview" title="Budget Box Total">
    <dxo-common-series-settings type="bar" argumentField="year" valueField="amount" [ignoreEmptyPoints]="true"> </dxo-common-series-settings>
    <dxo-series-template nameField="year"></dxo-series-template>
    <dxo-tooltip [enabled]="true" [format]="{ type: 'currency', precision: 2 }"></dxo-tooltip>
  </dx-chart>

  <!-- <dx-chart class="mt-3 col-sm-6" id="chart" [dataSource]="generalFundOverview" title="Budget Box Total">
  <dxi-series valueField="amount" name="Giving" color="green"></dxi-series>
  <dxi-series valueField="actualExpense" name="Expenses" color="red"></dxi-series>
  <dxo-common-series-settings argumentField="year" type="bar"> </dxo-common-series-settings>
  <dxo-tooltip [enabled]="true" [format]="{ type: 'currency', precision: 2 }"></dxo-tooltip>
</dx-chart> -->

<dx-chart class="mt-3 col-sm-6" id="chart" [dataSource]="thanksgiving" title="Thanksgiving Totals" (onPointClick)="onPointClick($event, true)">
  <dxi-series valueField="amount" name="Total"></dxi-series>
  <!-- <dxi-series valueField="operatingAmount" name="OperatingFund"></dxi-series> -->

  <dxo-common-series-settings argumentField="year" type="bar" valueField="amount" [ignoreEmptyPoints]="true"> </dxo-common-series-settings>
  <dxo-series-template nameField="year"></dxo-series-template>
  <dxo-tooltip [enabled]="true" [format]="{ type: 'currency', precision: 2 }"></dxo-tooltip>
</dx-chart>
</div>

<div class="mt-5 row">
  <label class="mt-2 me-3">Account</label>
  <dx-select-box
    class="col-sm-3"
    [items]="accounts"
    [(value)]="selectedAccount"
    valueExpr="id"
    displayExpr="name"
    [width]="150"
    (onValueChanged)="onAccountChange($event)"
  ></dx-select-box>
  <dx-chart class="mt-3 mb-5 col-sm-12" id="chart" [dataSource]="accountDetail" title="Account History (excluding Thanksgiving)">
    <dxo-common-series-settings type="bar" argumentField="month" valueField="amount" [ignoreEmptyPoints]="false">
      <dxo-label [visible]="true" [format]="{ type: 'currency', precision: 2 }"> </dxo-label>
    </dxo-common-series-settings>
    <dxo-series-template nameField="year"></dxo-series-template>
    <dxo-tooltip [enabled]="true" [format]="{ type: 'currency', precision: 2 }"></dxo-tooltip>
  </dx-chart>
</div>

<dx-pie-chart id="chart" [dataSource]="offeringTotals" title="Offering Dispersement" (onPointClick)="pointClickHandler($event)" (onLegendClick)="legendClickHandler($event)">
  <dxi-series argumentField="name" valueField="total"></dxi-series>
  <dxo-tooltip [enabled]="true" [format]="{ type: 'currency', precision: 2 }" [customizeTooltip]="customizeToolTipOffering"></dxo-tooltip>
  <dxo-export [enabled]="true"></dxo-export>
  <dxo-argument-axis [visualRange]="visualRange"> </dxo-argument-axis>
</dx-pie-chart>
<!-- <dx-range-selector *ngIf="true" [dataSource]="generalFund" [(value)]="visualRange">
<dxo-size [height]="120"></dxo-size>
<dxo-margin [left]="5"></dxo-margin>
<dxo-scale [minorTickCount]="1"></dxo-scale>
<dxo-behavior valueChangeMode="onMoving"></dxo-behavior>
<dxo-chart>
  <dxi-series argumentField="month" valueField="generalFundAmount"></dxi-series>
</dxo-chart>
</dx-range-selector> -->

<dx-chart class="mt-3" id="chart" [dataSource]="generalFundDistinct" title="Distinct Giving">
  <dxi-series valueField="totalDonations" name="Total"></dxi-series>
  <dxi-series valueField="distinctBoxes" name="Distinct"></dxi-series>
  <dxi-series valueField="duplicates" name="Duplicates"></dxi-series>
  <dxo-common-series-settings argumentField="date" type="bar">
    <!-- <dxo-label [visible]="true" [format]="{ type: 'fixedPoint', precision: '0' }"></dxo-label> -->
  </dxo-common-series-settings>

  <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeToolTip"></dxo-tooltip>
  <dxo-export [enabled]="true"></dxo-export>
</dx-chart>
</div>
